var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.257 59.922"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.931 29.954L1.258 7.299a4.282 4.282 0 116.065-6.047l25.687 25.67a4.274 4.274 0 01.125 5.9L7.341 58.673a4.282 4.282 0 11-6.065-6.047z"
  })));
}
export default SvgArrowNext;